// extracted by mini-css-extract-plugin
export default {"departments":"NF-z","departmentHeading":"OF-z","departmentSection":"PF-z","departmentName":"QF-z","departmentLink":"RF-z","expandIcon":"SF-z"};